<template>
  <PageContentLayoutOnly role="region" workorder-promote>
    <section class="section card">
      <div class="level pl-5 pr-5">
        <div class="pt-5 level-left level-item title">{{ $t('workorderrequest.title') }}</div>
        <div class="level-right" :style="{ display: 'flex', alignItems: 'center' }">
          <div class="level-item" :style="{ margin: 0 }">
            <svg
              width="30"
              height="30"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M15 19l-7-7 7-7"
              ></path>
            </svg>
          </div>
          <div class="level-item">
            <b-button label="Back to Work Order Requests" @click.prevent="returnToParent()" />
          </div>
        </div>
      </div>

      <!-- tabbable sections -->
      <LinksMenu
        aria-label="account settings tabs"
        :tabs="tabs"
        prefix="workorderrequest."
        :styles="{
          paddingLeft: '20px'
        }"
        :params="{
          id: $route.params.id
        }"
      >
        <section :style="{ overflowX: 'auto', flexGrow: 2 }">
          <SlideTransition :name="transitionName">
            <keep-alive>
              <router-view />
            </keep-alive>
          </SlideTransition>
        </section>
      </LinksMenu>
    </section>
  </PageContentLayoutOnly>
</template>

<script>
import { mapState } from 'vuex'
//
import SlideTransition from '@/components/transitions/Slide.vue'
import LinksMenu from '@/components/menus/Links'
//
import PageContentLayoutOnly from '@/containers/PageContentLayoutOnly'
//
import { data } from './keys/data'
import { methods } from './keys/methods'
import { watch } from './keys/watch'

export default {
  components: {
    LinksMenu,
    SlideTransition,
    PageContentLayoutOnly
  },

  data,

  computed: {
    ...mapState({
      unit: state => state.hoa.unit
    }),

    debug() {
      return this.unit
    }
  },

  watch,

  mounted() {
    this.reload()
  },

  methods,

  i18n: {
    messages: {
      en: { workorderrequest: { title: 'Work Order Request' } }
    }
  }
}
</script>

<style lang="scss" scoped>
.owner-avatar {
  margin: 1em auto 2em;
}

.card {
  box-shadow: 0 12px 18px 0 rgba(0, 0, 0, 0.05) !important;

  .card {
    border: 0 !important;
  }
}

.avatar-img {
  border: 1px solid #e7e8f2;
  padding: 0.25em;
}

.address-card {
  h5,
  h6 {
    margin: 0;
  }
}

.details-img {
  img {
    border-radius: 0.5em;
  }
}
</style>
